// Mock data for Dom's Pfotenexpress

export const services = [
  {
    id: 1,
    title: 'Kurzstrecken-Transport',
    description: 'Perfekt für schnelle Fahrten zum Tierarzt oder zur Tierpflege',
    icon: 'car',
    price: '2,20€/km',
    details: [
      '2,20€ pro Kilometer (nur Fahrstrecke)',
      'Anfahrt: 1,50€ innerhalb Hagen',
      'Anfahrt: 3,50€ außerhalb Hagen',
      'Rentner: 1,80€/km + Anfahrt',
      'Warteservice: 15€ je 30 Min (optional)',
      'Rückfahrt buchbar',
      'Notdienst (19:00-07:00 Uhr): +20€ Notfallpauschale'
    ]
  },
  {
    id: 2,
    title: 'Langstrecken-Transport',
    description: 'Für längere Reisen ab 150 km mit Ihrem geliebten Haustier',
    icon: 'route',
    price: '45€/Stunde',
    details: [
      'Ab 150 km Entfernung',
      '45€ je erwarteter Stunde (gesamte Fahrtzeit)',
      'Berechnung: Sternstraße 1 → Abholung → Ziel → Sternstraße 1',
      'Routenplanung via Google Maps',
      'Spontanbuchung möglich (nach Verfügbarkeit)',
      'Bei fester Planung: 50% Anzahlung empfohlen',
      'Keine Erstattung bei Absage durch Auftraggeber',
      'Bequem und sicher für Ihr Tier'
    ]
  },
  {
    id: 3,
    title: 'Notfall-Transport',
    description: '24/7 Notdienst zur Tierklinik verfügbar',
    icon: 'ambulance',
    price: 'Pauschal',
    details: [
      'Pauschalpreise je nach Wohnort & Zielklinik',
      'Hin- und Rückweg inklusive',
      'Tagsüber: 1 Std Warteservice inklusive',
      'Nachts: 2 Std Warteservice inklusive',
      'Ratenzahlung möglich (50% Anzahlung)'
    ]
  },
  {
    id: 4,
    title: 'Warteservice',
    description: 'Wir warten vor Ort, während Ihr Tier behandelt wird',
    icon: 'clock',
    price: '15€/30 Min',
    details: [
      'Tagsüber: 15€ je angefangene 30 Minuten',
      'Nachts: 20€ je angefangene 30 Minuten',
      'Bei Notfalltransporten teilweise inklusive',
      'Auf Wunsch buchbar'
    ]
  }
];

export const hygienInfo = {
  title: 'Hygiene & Desinfektion',
  regularDisinfection: 'Unser Fahrzeug wird regelmäßig professionell desinfiziert',
  infectiousTransport: {
    available: true,
    condition: 'Nach Absprache möglich',
    cost: 200,
    reason: 'Desinfektions- und Ausfallkosten (24 Std Fahrzeugausfall)',
    triggers: [
      'Transport von bekanntermaßen infektiösen Tieren (z.B. bei Giardien)',
      'Wenn beim Tierarzt/Tierklinik akut eine relevante Infektionskrankheit festgestellt wird'
    ]
  }
};

export const testimonials = [
  {
    id: 1,
    name: 'Ljiljana R.',
    rating: 5,
    text: 'Vielen Dank für die angenehme und kurzweilige Fahrt von Hagen an die Ostsee. Und ich bin auch mit dem Service und das es so spontan geklappt hat super zufrieden. Wir können dich und deinen Pfotenexpress zu 100% weiterempfehlen. Vielen lieben Dank!',
    date: '2024-12-04'
  },
  {
    id: 2,
    name: 'Aurora G. E.',
    rating: 5,
    text: 'Super freundlich zu Menschen und Tier, verständnisvoll, kommt direkt zur Hilfe sympathisch mitfühlend und sehr herzlich einfach super typ bin so froh das es so Menschen gibt',
    date: '2024-11-30'
  },
  {
    id: 3,
    name: 'Jascha E.',
    rating: 5,
    text: 'Kann kann ich nur empfehlen. Sehr zuverlässig, sehr tierlieb, sehr freundlich. Er zeig Mitgefühl, ist verständnisvoll. Wir hätten keinen besseren Fahrer kriegen können. ⭐⭐⭐⭐⭐⭐',
    date: '2024-11-29'
  },
  {
    id: 4,
    name: 'Buddy B.',
    rating: 5,
    text: 'Absolut zu empfehlen! Dom hat den ganzen Weg von Deutschland nach Portugal auf sich genommen um mich und meine 2 Hunde zurück nach Deutschland zu fahren. Sehr zuverlässig und sympatisch',
    date: '2024-11-17'
  },
  {
    id: 5,
    name: 'Brigitte P.',
    rating: 5,
    text: 'Gestern das erste Mal mit Dom\'s Pfotenexpress unterwegs gewesen. Obwohl spontan, hat alles super geklappt. Leider muss er morgen nach Portugal, sonst hätte ich ihn heute wieder gebucht. Sehr sympathisch. Bis bald!',
    date: '2024-11-11'
  },
  {
    id: 6,
    name: 'Stephanie S. M.',
    rating: 5,
    text: 'Vielen Dank an Dominik für den super freundlichen und schnellen Transport mit dem Dom\'s Fotenexpress, ein herzlichen dank. Sehr zu empfehlen. Gerne wieder!',
    date: '2024-11-04'
  },
  {
    id: 7,
    name: 'Marcel H.',
    rating: 5,
    text: 'Top! immer Pünktlich, sehr höflich und absolut faire Preise. Ganz klare Empfehlung',
    date: '2024-10-20'
  },
  {
    id: 8,
    name: 'Gabi S.',
    rating: 5,
    text: 'Sehr zu empfehlen. Pünktlich sehr freundlich, wir sind sicher ans Ziel gekommen. Wir werden deinen Service bestimmt öfter in Anspruch nehmen',
    date: '2024-10-06'
  }
];

// Gallery wird jetzt direkt aus der Datenbank geladen
export const gallery = [];

export const availableTimeSlots = [
  '08:00', '09:00', '10:00', '11:00', '12:00',
  '13:00', '14:00', '15:00', '16:00', '17:00', '18:00'
];

export const petTypes = [
  { value: 'dog', label: 'Hund', sizes: ['Klein (bis 10kg)', 'Mittel (10-25kg)', 'Groß (über 25kg)'] },
  { value: 'cat', label: 'Katze', sizes: ['Klein', 'Groß'] },
  { value: 'bird', label: 'Vogel', sizes: ['Klein', 'Groß'] },
  { value: 'rabbit', label: 'Kaninchen/Hase', sizes: ['Klein', 'Mittel', 'Groß'] },
  { value: 'rodent', label: 'Nagetier (Hamster, Meerschweinchen etc.)', sizes: ['Klein'] },
  { value: 'reptile', label: 'Reptil', sizes: ['Klein', 'Mittel', 'Groß'] },
  { value: 'other', label: 'Sonstiges', sizes: ['Klein', 'Mittel', 'Groß'] }
];

export const destinations = [
  { value: 'vet', label: 'Tierarzt' },
  { value: 'clinic', label: 'Tierklinik' },
  { value: 'groomer', label: 'Groomer/Pflege' },
  { value: 'other', label: 'Sonstiges Ziel' }
];

export const submitBooking = async (bookingData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      const bookingId = `BK${Date.now()}`;
      resolve({
        success: true,
        bookingId,
        message: 'Buchung erfolgreich! Sie erhalten in Kürze eine Bestätigung.'
      });
    }, 1000);
  });
};

export const calculatePrice = (distance, isWithinHagen, isSenior, tripType) => {
  let price = 0;
  
  if (tripType === 'short') {
    const kmRate = isSenior ? 1.80 : 2.20;
    const anfahrt = isWithinHagen ? 1.50 : 3.50;
    price = (distance * kmRate) + anfahrt;
  } else if (tripType === 'long') {
    const hours = Math.ceil(distance / 80);
    price = hours * 45;
  } else if (tripType === 'emergency') {
    if (distance < 10) price = 50;
    else if (distance < 20) price = 75;
    else if (distance < 30) price = 100;
    else price = 150;
  }
  
  return price.toFixed(2);
};

export const contactInfo = {
  name: "Dom's Pfotenexpress",
  company: "Dom's Pfotenexpress",
  owner: "Dominique Ewerling",
  address: "Sternstraße 1",
  postalCode: "58089",
  city: "Hagen",
  phone: "01573 969 69 42",
  email: "doms.pfotenexpress@gmail.com",
  facebook: "Dom's Pfotenexpress",
  coordinates: {
    lat: 51.3671,
    lng: 7.4653
  }
};

export const pfotenflatrate = {
  name: "Dom's Pfotenflatrate",
  monthlyPrice: 10,
  additionalPetPrice: 8.50,
  paymentOptions: [
    { period: 'Quartal', price: 30, originalPrice: 30, saving: 0 },
    { period: 'Halbjährlich', price: 57, originalPrice: 60, saving: 3 },
    { period: 'Jährlich', price: 110, originalPrice: 120, saving: 10 }
  ],
  startDate: '14.02.2026',
  purchaseDate: 'sofort',
  benefits: [
    '3 Fahrten zum Tierarzt innerhalb des Ortsgebiets jährlich',
    '1 Fahrt zur Tierklinik je Halbjahr (2 pro Jahr)',
    'Bonus: Werden beide Tierklinik-Fahrten nicht genutzt, wird 1 Fahrt ins Folgejahr übertragen',
    'Je 1 Stunde Warteservice pro Fahrt inklusive',
    'Standard-Anfahrtskosten fallen bei allen Transporten an',
    '+ 5€ Zusatzgebühr bei Tierklinik-Transporten'
  ],
  conditions: [
    'Leistungsbeginn: 14 Tage nach Vertragsabschluss (Schutz vor Missbrauch)',
    'Vertragslaufzeit: 1 Jahr ab Leistungsbeginn',
    'Kündbar bis spätestens 4 Wochen vor Vertragsende',
    'Termine: mindestens 7 Tage im Voraus empfohlen (kürzere Frist möglich, aber ohne Garantie)',
    'Weitere Tiere: +8,50€/Monat – jedes Tier erhält eigenes Kontingent',
    'Fahrten sind flexibel zwischen den registrierten Tieren übertragbar'
  ],
  savingsExample: {
    vetTrips: '3 Fahrten zum Tierarzt (inkl. Rückweg): ca. 35€ = 105€',
    clinicTrips: '2 Fahrten zur Tierklinik je Halbjahr (z.B. Iserlohn-Duisburg): 260€ = 520€',
    totalNormal: 'Gesamt ohne Flatrate: 615€',
    flatrateCost: 'Pfotenflatrate: 110€ jährlich + Zusatzkosten',
    savings: 'Bis zu 450€ Ersparnis!'
  }
};

export const emergencyPrices = {
  description: 'Pauschalpreise für Notfall-Transporte zu den Tierkliniken (Hin- und Rückweg inklusive)',
  waitingService: {
    day: {
      included: '1 Stunde inklusive',
      additional: '15€ je angefangene 30 Minuten'
    },
    night: {
      included: '2 Stunden inklusive',
      additional: '20€ je angefangene 30 Minuten'
    }
  },
  paymentOptions: 'Ratenzahlung bis zu 3 Monaten möglich bei 50% Anzahlung',
  cities: [
    {
      name: 'Hagen, Witten, Wetter, Herdecke',
      clinics: [
        { name: 'Tierklinik Haan', price: 160 },
        { name: 'Tierklinik Recklinghausen', price: 180 },
        { name: 'Tierklinik Duisburg', price: 200 }
      ]
    },
    {
      name: 'Gevelsberg, Ennepetal',
      clinics: [
        { name: 'Tierklinik Haan', price: 130 },
        { name: 'Tierklinik Recklinghausen', price: 160 },
        { name: 'Tierklinik Duisburg', price: 170 }
      ]
    },
    {
      name: 'Breckerfeld',
      clinics: [
        { name: 'Tierklinik Haan', price: 170 },
        { name: 'Tierklinik Recklinghausen', price: 180 },
        { name: 'Tierklinik Duisburg', price: 210 }
      ]
    },
    {
      name: 'Schwerte',
      clinics: [
        { name: 'Tierklinik Recklinghausen', price: 160 },
        { name: 'Tierklinik Haan', price: 190 },
        { name: 'Tierklinik Duisburg', price: 230 }
      ]
    },
    {
      name: 'Iserlohn',
      clinics: [
        { name: 'Tierklinik Recklinghausen', price: 190 },
        { name: 'Tierklinik Haan', price: 220 },
        { name: 'Tierklinik Duisburg', price: 260 }
      ]
    }
  ]
};